var DEFAULT_STRINGS = {
    warningHeader: 'Voulez-vous continuer votre session ?',
    warningBody: 'Pour des raisons de sécurité, votre session expirera à moins que vous ne choisissiez de continuer.',
    warningButton: 'Continuer',
    sessionHeader: 'Votre session a expiré.',
    sessionBody: 'Pour des raisons de sécurité, votre session a expiré.',
    sessionButton: 'OK'
};
export default DEFAULT_STRINGS;
